/**
 * Suite Dashboard Page
 *
 * Main entry point for the ContentSage AI Suite experience.
 * Used by iOS, Android, and Web (non-Wix) platforms.
 *
 * Features:
 * - Full suite of AI tools (BlogCraft, PlanCraft, Calendar)
 * - Enhanced mobile navigation
 * - Stripe billing (not Wix billing)
 */

import React, { useCallback } from 'react';
import { SuiteDashboard } from '../components/mobile/SuiteDashboard';
import { useAuth } from '../contexts/AuthContext';
import ChatwootWidget from '../components/ChatwootWidget';

const SuiteDashboardPage: React.FC = () => {
  const { getAuthToken, user } = useAuth();

  const getAuthHeaders = useCallback(async (): Promise<Record<string, string>> => {
    try {
      const token = await getAuthToken();
      if (!token) return {};

      return {
        Authorization: `Bearer ${token}`,
      };
    } catch (error) {
      console.error('Error getting auth headers:', error);
      return {};
    }
  }, [getAuthToken]);

  return (
    <>
      <ChatwootWidget
        userEmail={user?.email ?? undefined}
        userName={user?.displayName ?? undefined}
      />
      <SuiteDashboard getAuthHeaders={getAuthHeaders} />
    </>
  );
};

export default SuiteDashboardPage;
